import { ESeoUrlActionType } from './types';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export const clearSeoUrl = actionGenerator<ESeoUrlActionType.ClearSeoUrl>(ESeoUrlActionType.ClearSeoUrl);
